<nz-modal
  [nzVisible]="isVisible()"
  [nzTitle]="undefined"
  nzCentered
  nzWrapClassName="notify-before-restart__popup"
  nzWidth="fit-content">
  <ng-container *nzModalContent>
    <div class="notify-before-restart__wrapper">
      <span
        class="notify-before-restart__icon"
        nz-icon
        nzType="aio:warning"></span>
      <h2 class="notify-before-restart__title">System Restart Required</h2>
      <p class="notify-before-restart__description">
        The tablet needs to restart for critical updates. The system will
        restart automatically.
      </p>
      <div class="notify-before-restart__timer--container">
        <span class="notify-before-restart__timer--title"> Restarting in </span>
        <span class="notify-before-restart__timer"
          >{{ tickingInterval() }}
        </span>
        <span class="notify-before-restart__timer--subtitle"> Seconds </span>
      </div>
      <div class="notify-before-restart__actions">
        <button
          class="notify-before-restart__action"
          (click)="delayRestart.emit()">
          In 10 minutes
        </button>
        <button
          class="notify-before-restart__action now"
          (click)="restartNow.emit()">
          Restart now
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>
